module.exports = __webpack_public_path__ + "img/hubspot.1981409c.webp";